import { PopoverRangeDate } from '../../components/popoverRangeDate/PopoverRangeDate';
import { PopoverCheckboxFilter } from '../../components/popoverCheckboxFilter/PopoverCheckboxFilter';
import { DrawerCustom } from '../../components/drawer/Drawer';
import { Button } from '../../components/buttons/Button';
import { NOTE_STATUS_OPTIONS, statusStudentsFilter, statusSubscriptionFilter } from '../../static/data';
import { FunnelIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/20/solid';

export const DrawerFiltersStudents = ({
	isOpen,
	toggleDrawer,
	formData,
	setFormData,
	onClear,
	onApply,
}) => {
	return (
		<DrawerCustom
			isOpen={isOpen}
			toggleDrawer={toggleDrawer}
			direction='left'
			title='Filtros de estudiantes'
			subtitle='Selecciona y aplica filtros para la lista.'
			footer={(
				<div className='flex items-center justify-end gap-4 overflow-hidden'>
					<Button
						type="button"
						variant="secondary"
						onClick={toggleDrawer}
					>
						Cerrar
					</Button>
					<Button
						type="button"
						variant="reject"
						onClick={onClear}
					>
						Limpiar
					</Button>
					<Button
						type="button"
						variant="primary"
						onClick={onApply}
					>
						Aplicar
					</Button>
				</div>
			)}
		>
			<div className='w-full flex flex-col py-4 px-6 gap-4'>
				<div className='rounded-2xl border border-indigo-100 bg-gradient-to-r from-indigo-50 via-white to-violet-50 px-4 py-4 shadow-sm'>
					<div className='flex items-start gap-3'>
						<div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-600 text-white shadow-md shadow-indigo-400/30'>
							<FunnelIcon className='h-5 w-5' aria-hidden='true' />
						</div>
						<div className='min-w-0'>
							<h3 className='text-sm font-semibold text-gray-900'>Refina tu búsqueda</h3>
							<p className='mt-1 text-xs leading-relaxed text-gray-600'>
								Selecciona estatus y fechas para encontrar estudiantes más rápido.
							</p>
						</div>
					</div>
					<div className='mt-3 inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-indigo-700'>
						<AdjustmentsHorizontalIcon className='h-3.5 w-3.5' aria-hidden='true' />
						Filtros avanzados
					</div>
				</div>
				<PopoverCheckboxFilter
					state={formData}
					setState={setFormData}
					property='statusSubscription'
					options={statusSubscriptionFilter}
					title='Estatus de suscripción'
					subtitle='Filtra estudiantes por su estado actual de suscripción.'
					placeholderLabel='Estatus de suscripción'
					handleApllyFilters={() => { }}
					handleRemoveFilter={() => { }}
					hideActionButtons
				/>
				<PopoverCheckboxFilter
					state={formData}
					setState={setFormData}
					property='statusStudent'
					options={statusStudentsFilter}
					title='Estatus de estudiante'
					subtitle='Filtra estudiantes por su estado en la plataforma.'
					placeholderLabel='Estatus de estudiante'
					handleApllyFilters={() => { }}
					handleRemoveFilter={() => { }}
					hideActionButtons
				/>
				<PopoverCheckboxFilter
					state={formData}
					setState={setFormData}
					property='noteStatus'
					options={NOTE_STATUS_OPTIONS}
					title='Estatus de notas'
					subtitle='Estudiantes con al menos una nota en los estatus seleccionados.'
					placeholderLabel='Estatus de notas'
					handleApllyFilters={() => { }}
					handleRemoveFilter={() => { }}
					hideActionButtons
				/>
				<PopoverRangeDate
					state={formData}
					setState={setFormData}
					properties={['fromDate', 'toDate']}
					popoverTitle='Fecha de vencimiento de suscripción'
					popoverSubtitle='Filtra estudiantes según la fecha límite de pago de su suscripción (vencimiento).'
					emptySummaryLabel='Vencimiento de suscripción'
					handleApllyFilters={() => { }}
					handleRemoveFilter={() => { }}
					hideActionButtons
				/>
			</div>
		</DrawerCustom>
	);
};
